import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@doxyme/ui';
import { useHistory } from 'react-router-dom';
import './blacklisted-page.scss';
export const BlacklistedPage = () => {
    const history = useHistory();
    history.listen((newLocation, action) => {
        if (action === 'POP') {
            history.go(1);
        }
    });
    const handleButtonClick = () => {
        window.sessionStorage.setItem('hasAcknowledgedBlacklistedMessage', 'true');
        const param = new URLSearchParams(window.location.search).get('redirect');
        history.push(param);
        history.go(0);
    };
    return (<section className="blacklisted-page">
      <div className="blacklisted-page__content">
        <h1>
          <FormattedMessage id="blacklisted-page.title" defaultMessage="Uh oh!"/>
        </h1>
        <img className="blacklisted-page__img" src="/assets/images/ua.svg" alt="blacklisted"/>
        <h3>
          <FormattedMessage id="blacklisted-page.subtitle" defaultMessage="It appears you have a Russian IP address."/>
        </h3>
        <p className="blacklisted-page__message">
          <FormattedMessage id="blacklisted-page.message" defaultMessage="Because of Russia's unprovoked and unjust war on Ukraine we no longer support doxy.me in Russia. If you believe you have received this message in error please acknowledge the message and continue."/>
        </p>
        <Button className="blacklisted-page__button" data-testid="blacklisted__button" onClick={handleButtonClick} size="medium">
          <FormattedMessage id="blacklisted-page.button" defaultMessage="Acknowledge and continue"/>
        </Button>
      </div>
    </section>);
};
